import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  RequestTypes,
  registerItemKeys,
} from '@core/react-query/features/registers/registers/register/items/item'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { registerItemsKeys } from '@core/react-query/features/registers/registers/register/items'

export const useCreateRegisterItemScheduledInspection = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['createRegisterItemScheduledInspection']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...registerItemKeys.createRegisterItemScheduledInspection,
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(registerItemsKeys.itemsByRegisterId._def)
      queryClient.invalidateQueries(
        registerItemKeys.byId({
          registerId: variables.registerId,
          registerItemId: variables.registerItemId,
        }),
      )
      options?.onSuccess?.(data, variables, context)
    },
  })
}
